/**
 * canal-callcenter.js
 *
 * Atribuye a "Call Center" las ventas que llegan por un link enviado por el call center.
 *
 * Como funciona:
 *   1. El call center manda un link normal de la tienda con el UTM de origen:
 *        https://lasertam.com/products/hifu-facial?utm_source=callcenter
 *      (se aceptan variantes: call-center, call_center, "Call Center", en cualquier
 *      combinacion de mayusculas).
 *   2. Al aterrizar, se recuerda en el navegador por 7 dias (localStorage). Asi la compra
 *      cuenta aunque el cliente navegue por otras paginas o vuelva otro dia.
 *   3. Al agregar al carrito, la linea lleva la propiedad oculta "_canal" = "Call Center".
 *      Va DENTRO de la misma peticion de "Agregar" (input oculto en el <form>), igual que
 *      _sede_handle: no hace ninguna llamada extra al carrito.
 *   4. Un Flow de Shopify lee esa propiedad de linea y etiqueta la orden "canal:call-center".
 *
 * Por que propiedad de linea y NO atributo del carrito:
 *   sede.js y vendedor.js ya escriben atributos del carrito (/cart/update.js) al cargar la
 *   pagina. Shopify pierde actualizaciones cuando varias escrituras llegan a la vez (medido:
 *   ~1 de cada 4 pierde un atributo), asi que sumar otra escritura hacia que la sede quedara
 *   "sin definir". Una propiedad de linea viaja en el "Agregar", sin carrera.
 *
 * Reglas:
 *   - Gana el ultimo link del call center dentro de los 7 dias. Entrar por otro origen
 *     (Google, Instagram, directo) NO borra la atribucion del call center.
 *   - Sin link del call center (o vencido) la linea no lleva la propiedad = venta web normal.
 *
 * Auto-inicializa. No bloquea la compra si algo falla.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lasertam_canal';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var CANAL = 'Call Center';
  var INPUT_NAME = 'properties[_canal]';
  var FORM_SELECTOR = 'form[action*="/cart/add"]';

  function esCallCenter(valor) {
    return (valor || '').toString().toLowerCase().replace(/[\s_-]+/g, '') === 'callcenter';
  }

  function leerGuardado() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.ts || Date.now() - data.ts > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function guardar() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ canal: CANAL, ts: Date.now() }));
    } catch (e) { /* navegacion privada o sin storage: no se recuerda entre paginas */ }
  }

  // Si el link trae el UTM del call center, se recuerda (renueva los 7 dias).
  function capturar() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (esCallCenter(params.get('utm_source'))) guardar();
  }

  // Deja el input oculto en el <form> si hay atribucion vigente; lo quita si ya vencio.
  function marcarForm(form) {
    if (!form || !form.querySelector) return;
    var existente = form.querySelector('input[name="' + INPUT_NAME + '"]');
    if (!leerGuardado()) {
      if (existente && existente.parentNode) existente.parentNode.removeChild(existente);
      return;
    }
    if (existente) {
      existente.value = CANAL;
      return;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = INPUT_NAME;
    input.value = CANAL;
    form.appendChild(input);
  }

  function marcarTodos() {
    var forms = document.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) marcarForm(forms[i]);
  }

  function init() {
    try {
      capturar();
      marcarTodos();

      // Guard de MkFormGuards (ver product-form.js): corre sincronico justo antes de armar
      // el pedido del "Agregar", asi cubre formularios creados despues de la carga
      // (quick-add, recargas de seccion). Siempre devuelve true: nunca bloquea la compra.
      window.MkFormGuards = window.MkFormGuards || [];
      window.MkFormGuards.push(function (form) {
        try { marcarForm(form); } catch (e) { /* no bloquear */ }
        return true;
      });

      // Formularios que el tema inserta despues (modales de quick-add, theme editor).
      document.addEventListener('shopify:section:load', marcarTodos);
      if (typeof MutationObserver === 'function' && document.body) {
        var pendiente = false;
        new MutationObserver(function () {
          if (pendiente) return;
          pendiente = true;
          setTimeout(function () { pendiente = false; marcarTodos(); }, 150);
        }).observe(document.body, { childList: true, subtree: true });
      }
    } catch (e) { /* no bloquear la compra */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
